
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { ensureArray } from '~/utility/array'
import { GeoCircle } from '~/utility/geo/GeoLocation'
import { routeToFilters } from '../../../pu-links/infrastructure/routeToFilters'
import { SearchLinkGenerator } from '../../../url/generators/SearchLinkGenerator'

@Component
export default class LowResultsPoint extends Vue {
  @Prop({ required: true })
    area: GeoCircle

  step = 5
  maxDistanceFromActualWithin = 40
  topDistanceLimit = 95

  async redirect() {
    const filters = routeToFilters(this.$route)
    const urlData = new SearchLinkGenerator().getUrlData({
      excludeType: 'nearby',
      filters: { ...filters, area: undefined },
    })
    await this.$router.push({
      path: urlData.path,
      query: urlData.query as Record<string, any>,
    })
  }

  get queryPlacename() {
    return ensureArray(this.$route.query.placename)[0] || undefined
  }

  get proposedDistances(): number[] {
    const propositions: number[] = []
    const rangeMiles =
      this.area.rangeMiles || this.$config.public.defaultWithinRange
    for (
      let index = rangeMiles + this.step;
      index <= rangeMiles + this.maxDistanceFromActualWithin &&
      index <= this.topDistanceLimit;
      index = index + this.step
    ) {
      propositions.push(index)
    }
    return propositions
  }
}
